export default {
  paragraph: "For requesting additional documents without changing the customer approval status, the API sends a 'document_required' webhook like:",
  path: "notification_document_required",
  request: {
    method: "POST",
    payloads: [
		 {
			title: "Notification",
			content: { 
      "notification": {
        "type": "document_required",
        "subject_id": "UUID",
        "required_documents": ["revenue_tax_declaration", "proof_of_address"],
        "secret": "some-secret"
				}
			 }
		  }
		]
  }
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/WebHook/NotificationDocumentRequired.js